



















































import { Vue, Component } from "vue-property-decorator";
import CollapseButtonComponent from "@/app/views/nubii/components/sidebar/components/collapseButton.component.vue";
import SuperSpacesComponent from "@/app/views/nubii/components/sidebar/superSpacesList/superSpaces.component.vue";

@Component({
  name: "super-spaces-list-component",
  components: { CollapseButtonComponent, SuperSpacesComponent },
})
export default class SuperSpacesListComponent extends Vue {
  search = "";
  searchTimeOut = null;
  mounted() {
    this.openSuperSpaceContainerHeight();
  }
  get onBoarding(): void {
    return this.$store.getters["SystemStore/getShowCompleteOnBoarding"];
  }
  get superSpacesList() {
    const superSpaces = this.$store.getters["SuperSpaceStore/getSuperSpaces"];
    return superSpaces.filter((a) =>
      this.search !== ""
        ? a.name
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .includes(
              this.search
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
            )
        : a
    );
  }
  getMoreSuperSpaces(): void {
    this.$store.dispatch("SuperSpaceStore/getSuperSpacesAction", {
      pagination: false,
      callback: async (response) => {
        // do nothing
      },
      callbackError: (error) => {
        console.log("City On ", error);
      },
    });
  }
  get disabledLoader(): boolean {
    const lastPage =
      this.$store.getters["SuperSpaceStore/getLastPageSuperSpaces"];
    const page =
      this.$store.getters["SuperSpaceStore/getSuperSpacesAvailablePage"];
    return page > lastPage;
  }

  async onSearch(): Promise<void> {
    const lengthUsers = this.superSpacesList.filter((a) =>
      this.search !== ""
        ? a.name
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .includes(
              this.search
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
            )
        : a
    ).length;
    if (lengthUsers < 5) {
      if (this.searchTimeOut) clearTimeout(this.searchTimeOut);
      this.searchTimeOut = setTimeout(() => {
        this.$store.dispatch("SuperSpaceStore/getSuperSpacesAction", {
          name: this.search,
          pagination: false,
          callback: async (response) => {
            //do nothing
          },
          callbackError: (error) => {
            console.log("City On ", error);
          },
        });
      }, 1000);
    }
  }
  openSuperSpaceContainerHeight(): void {
    const superSpaceListContainer = document.getElementById(
      "space-list-container"
    );
    if (superSpaceListContainer) {
      const superSpaceContainer = document.getElementById("space-list");
      superSpaceContainer.style.height =
        superSpaceListContainer.clientHeight - 150 + "px";
    }
  }
}
